export default __webpack_public_path__ + "static/mobile-banner-2d6983488520d4c819e6c2088148c19e.png";